/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "M26.396,9.4293 C26.763,9.5883 27,9.9483 27,10.3473 C27,10.7463 26.763,11.1073 26.396,11.2653 L10,18.3533 L10,29.0003 C10,29.5523 9.553,30.0003 9,30.0003 C8.447,30.0003 8,29.5523 8,29.0003 L8,17.6953 L8,3.0003 C8,2.8783 8.029,2.7623 8.07,2.6523 C8.079,2.6293 8.087,2.6063 8.098,2.5833 C8.145,2.4823 8.205,2.3883 8.283,2.3073 C8.297,2.2933 8.313,2.2823 8.328,2.2693 C8.367,2.2333 8.405,2.1943 8.451,2.1643 C8.488,2.1403 8.529,2.1263 8.568,2.1073 C8.592,2.0953 8.613,2.0833 8.638,2.0733 C8.744,2.0313 8.855,2.0093 8.969,2.0063 C8.98,2.0063 8.989,2.0003 9,2.0003 C9.016,2.0003 9.028,2.0083 9.044,2.0083 C9.156,2.0133 9.268,2.0323 9.374,2.0753 C9.38,2.0783 9.387,2.0783 9.393,2.0813 C9.395,2.0813 9.396,2.0813 9.396,2.0823 L26.396,9.4293 Z M10,16.1743 L23.479,10.3473 L10,4.5213 L10,16.1743 Z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;